export const CARD_USER_EDUCATION = {
  EDUCATION: 'Education'
};

export const CARD_USER_EXPERIENCE = {
  EXPERIENCE: 'Experience'
};

export const CARD_USER_ATTENDANCE = {
  TOTAL_TIME: 'Total Time Tracked',
  TOTAL_BREAK: 'Total Break Time'
};

export const CARD_PERFORMANCE = {
  PERFORMANCE: 'Performance'
};
